import { css } from 'styled-components';
import { cssVar } from './variables.js';

const cssHoverBase = css([
  `&{position:relative;}&:before{content:'';display:block;position:absolute;inset:0;background:`,
  `;z-index:10;pointer-events:none;transition:0.1s;opacity:0;border-radius:1rem;}&:hover:before{opacity:1;}`
], cssVar["resource-hover-overlay-color"]);

export { cssHoverBase };
//# sourceMappingURL=sharedCss.js.map
